export default __webpack_public_path__ + "static/service-shape2-7a843d30d75b724decfeb6e2d3a161a2.png";